import stylex from '@stylexjs/stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';

export const styles = stylex.create({
  container: {
    fontFamily: fonts.din2014Regular,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  header: {
    display: 'flex',
    padding: '16px 24px',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
  },
  headerText: {
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '32px',
    color: colors.primaryText,
  },

  sendInvite: {
    display: 'flex',
    padding: '0 24px 24px 24px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    alignSelf: 'stretch',
  },
  guestListFilter: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    padding: '0 24px 8px 24px',
  },
  sendInviteText: {
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '24px',
    color: colors.primaryText,
  },
  sendInviteRow: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: '8px',
  },
  iconButton: {
    display: 'flex',
    alignItems: 'center',
    ':not(#__unused__) > button': {
      padding: 0,
      width: '36px',
      height: '36px',
    },
  },
  iconButtonHover: {
    ':hover svg path': {
      fill: colors.accentIcon,
    },
  },
  actionButton: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '28px',
    gap: '10px',
  },
});
